import { render, staticRenderFns } from "./WaitingValuesAdd.vue?vue&type=template&id=e2ec1c84&"
import script from "./WaitingValuesAdd.vue?vue&type=script&lang=js&"
export * from "./WaitingValuesAdd.vue?vue&type=script&lang=js&"
import style0 from "./WaitingValuesAdd.vue?vue&type=style&index=0&id=e2ec1c84&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports